import React, { ReactNode } from 'react';
import { isValidSlug } from 'helpers/utils';
import { Link } from 'gatsby';

type LinkProps = {
  to: string,
  ariaLabel?: string,
  role?: React.AriaRole,
  tabIndex?: number,
  className?: string,
  children?: ReactNode | null,
  newTab?: boolean
};

export const SmartLink: React.FC<LinkProps> = ({
  to, ariaLabel = '', role, tabIndex, children = null, className = '', newTab,
}) => {
  const isSlug = isValidSlug(to);
  if (isSlug) {
    return (
      <Link
        to={to}
        className={className}
        aria-label={ariaLabel}
        role={role}
        tabIndex={tabIndex}
      >
        {children}
      </Link>
    );
  }
  return (
    <a className={className} href={to} aria-label={ariaLabel} target={newTab ? '_blank' : '_self'} rel={newTab ? 'noreferrer' : ''}>
      {children}
    </a>
  );
};
